import { I01EVAECSQUALI_State } from '@batical/types/src'

const I01EVAECSQUALI: I01EVAECSQUALI_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_typeCalcul: 0,
  in_t1_Ddo: 0.0,
  in_t1_ba: 0.0,
  in_t2_do: 0.0,
  in_t2_ba: 0.0,
  in_t3_ev_lav_ba: 0.0,
  in_t3_ba_do: 0.0,
  in_t4_ba: 0.0,
  in_t4_ba_do: 0.0,
  in_t56_ba: 0.0,
  in_t56_ba_do: 0.0,
  in_T56_2ba: 0.0,
  in_volume: 0.0,
  in_tempFroide: 10.0,
  in_tempBouclage: 55.0,
  in_tempStackage: 80.0,
  in_tempRetour: 35.0,
  res_effEchangeur: 0.0,
  res_debitDTU: 0.0,
  res_puissMiniQualitel: 0.0,
  res_modePuissance: '',
  res_puissance: 0.0,
  res_totalLogementStandard: 0.0,
  res_s1: 0.0,
  res_s2: 0.0,
  res_s3: 0.0,
  res_simuDTU: 0.0,
  mode: 'none',
  calcul_code: 'I01EVAECSQUALI'
}

export default I01EVAECSQUALI
